<form [formGroup]="form" *ngIf="!form.controls.input.disabled">
  <mat-form-field appearance="outline" class="mat-form-field">
    <textarea
      #textarea
      matInput
      type="text"
      formControlName="input"
      [name]="outputInfoStore.state().output.name"
    >
    </textarea>
    <mat-hint align="end">
      Characters remaining: {{ maxLength - textarea.value.length }}
    </mat-hint>
    <mat-error *ngIf="form.controls.input.hasError('maxlength')">
      You are over the limit of {{ maxLength }} by
      {{ textarea.value.length - maxLength }} characters.
    </mat-error>
  </mat-form-field>
</form>
<p class="read-only-text" *ngIf="form.controls.input.disabled">
  {{ readOnlyText$ | async }}
</p>
<div
  *ngIf="trainingAnswer$ | async as trainingAnswer"
  class="training-container"
>
  <h3-training-answer-icon></h3-training-answer-icon>
  <p class="training-answer-text body-01">
    {{ trainingAnswer }}
  </p>
</div>
